import React from 'react';
import getSurcharges from '../selectors/getSurcharges';
import { useAppSelector } from '../app/hooks';
import Line from './Line';
import DeliverySurchargeLine from './DeliverySurchargeLine';

import { OrderingSelectors } from 'polygon-ordering';
import { useTranslation } from 'react-i18next';

const { getDeliveryFee } = OrderingSelectors;

const Surcharges = () => {
  const { t } = useTranslation();

  const surcharges = useAppSelector(getSurcharges);
  const deliveryFee = useAppSelector(getDeliveryFee);

  return (
    <div>
      {surcharges.map(surcharge => {
        const isDeliverySurcharge = surcharge?.description?.toLowerCase().startsWith('delivery');
        return (
          <div className="py-1" key={surcharge.description}>
            {isDeliverySurcharge && deliveryFee?.discountedDeliveryFee !== undefined ? (
              <DeliverySurchargeLine
                label={surcharge?.description ?? t('flattenedDeliverySurcharge')}
                original={
                  deliveryFee && deliveryFee.deliveryFee ? deliveryFee.deliveryFee : undefined
                }
                amount={Number(surcharge.amount)}
                deemphasised
              />
            ) : (
              surcharge.amount && (
                <Line
                  label={surcharge?.description ?? t('flattenedDeliverySurcharge')}
                  amount={Number(surcharge.amount)}
                  deemphasised
                />
              )
            )}
          </div>
        );
      })}
    </div>
  );
};

export default Surcharges;
